module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank",
      "alt": _vm.alt,
      "title": _vm.title
    }
  }, [_c('i', {
    class: _vm.fa_class
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d96e30f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialIcon.vue
// module id = 863
// module chunks = 2